//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System Email Templates */
export const SystemEmail = {
    /** Gets the template guid for a Assessment Request system email */
    AssessmentRequest: "41FF4269-7B48-40CD-81D4-C11370A13DED",
    /** Gets the template guid for the Attendance email */
    AttendanceNotification: "CA794BD8-25C5-46D9-B7C2-AD8190AC27E6",
    /** Gets the template guid for the Exception Notification email */
    ConfigExceptionNotification: "75CB0A4A-B1C5-4958-ADEB-8621BD231520",
    /** Gets the template guid for the Job Notification email */
    ConfigJobNotification: "691FEA1B-E5C4-4BF8-A7CD-C588F5C63CA8",
    /** Gets the template guid for digital signature invite */
    DigitalSignatureInvite: "791F2DE4-5A59-60AE-4F2F-FDC3EBC4FFA9",
    /** Gets the template guid for finance pledge confirmation email */
    FinancePledgeConfirmation: "73E8D035-61BB-495A-A87F-39007B98834C",
    /** Gets the template guid for group attendance reminder */
    GroupAttendanceReminder: "ED567FDE-A3B4-4827-899D-C2740DF3E5DA",
    /** Gets the template guid for a note approval notification */
    NoteApprovalNotification: "B2E3D75F-681E-430F-82C9-D0D681040FAF",
    /** Gets the template guid for a notewatch notification */
    NotewatchNotification: "21B92DE2-6825-45F3-BD27-43B47FE490D8",
    /** Gets the template guid for the Prayer Comments Notification */
    PrayerRequestCommentsNotification: "FAEA9DE5-62CE-4EEE-960B-C06103E97AA9",
    /** Gets the template guid for event registration confirmation */
    RegistrationConfirmation: "7B0F4F06-69BD-4CB4-BD04-8DA3779D5259",
    /** Gets the template guid for event registration notification */
    RegistrationNotification: "158607D1-0772-4947-ADD6-EA31AB6ABC2F",
    /** The scheduling confirmation email */
    SchedulingConfirmation: "F8E4CE07-68F5-4169-A865-ECE915CF421C",
    /** The scheduling remainder email */
    SchedulingRemainder: "8A20FE79-B73C-447A-82B1-416F9B50C038",
    /** The scheduling response email */
    SchedulingResponse: "D095F78D-A5CF-4EF6-A038-C7B07E250611",
    /** Gets the template guid for the Account Created email */
    SecurityAccountCreated: "84e373e9-3aaf-4a31-b3fb-a8e3f0666710",
    /** Gets the template guid for the Confirm Account email */
    SecurityConfirmAccount: "17aaceef-15ca-4c30-9a3a-11e6cf7e6411",
    /** Gets the template guid for the Forgot Username email */
    SecurityForgotUsername: "113593ff-620e-4870-86b1-7a0ec0409208",
    /** Gets the template guid for a Spark Data notification */
    SparkDataNotification: "CBCBE0F0-67FB-6393-4D9C-592C839A2E54",
    /** Gets the template guid for workflow form notifications */
    WorkflowFormNotification: "88C7D1CC-3478-4562-A301-AE7D4D7FFF6D",
};
